.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

// Variant: image - has border
.image {
  border: 1px solid var(--color-grey-light);
  background-color: var(--color-surface-primary);
}

// Variant: icon - no border
.icon {
  // No additional styles for icon variant
}

// Variant: initials - primary colored background with white text
.initials {
  background-color: var(--color-primary-base);
}

.initialsText {
  @include metadata-medium;
  line-height: 1;
  color: var(--color-primary-on-primary);
  user-select: none;
}

// The actual img element
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
